const { ref, watch } = require('vue')

export function debounce(func, delay) {
    let timeout, args, context, timestamp, result

    delay ??= 100

    function deferred() {
        const last = Date.now() - timestamp

        if (last < delay && last >= 0) {
            timeout = setTimeout(deferred, delay - last)
        } else {
            timeout = null
            result = func.apply(context, args)
            context = args = null
        }
    }

    return function () {
        context = this
        args = arguments
        timestamp = Date.now()

        if (!timeout) timeout = setTimeout(deferred, delay)

        return result
    }
}

export function debouncedRef(sourceRef, interval = 500) {
    const debounced = ref(sourceRef.value)

    watch(
        sourceRef,
        debounce(() => (debounced.value = sourceRef.value), interval)
    )

    return debounced
}
